import * as React from 'react';
import { Typography, styled } from '@mui/material';
import { BlocksContent } from '@strapi/blocks-react-renderer';
import { Image } from '../../types/blocks/image';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

interface RichTextWithImageProps {
  element: { content: BlocksContent; image: Image; id: number };
}

const RichTextContainer = styled('div')(({ theme }) => ({
  '& h1': {
    ...theme.typography.h1,
    marginBottom: theme.spacing(2),
  },
  '& h2': {
    ...theme.typography.h2,
    marginBottom: theme.spacing(2),
  },
  '& h3': {
    ...theme.typography.h3,
    marginBottom: theme.spacing(2),
  },
  '& h4': {
    ...theme.typography.h4,
    marginBottom: theme.spacing(2),
  },
  '& h5': {
    ...theme.typography.h5,
    marginBottom: theme.spacing(2),
  },
  '& h6': {
    ...theme.typography.h6,
    marginBottom: theme.spacing(2),
  },
  '& p': {
    ...theme.typography.body1,
    marginBottom: theme.spacing(2),
  },
  '& ul': {
    paddingLeft: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  '& li': {
    ...theme.typography.body1,
    marginBottom: theme.spacing(1),
  },
}));

export const RichTextWithImageBlock: React.FC<RichTextWithImageProps> = ({ element }) => (
  <RichTextContainer className="py-8 md:py-16 px-4 md:px-8 lg:px-10 xl:px-[80px] max-w-[1600px] mx-auto">
    <Typography variant="body1" component="div">
      <BlocksRenderer key={element.id} content={element.content} />
    </Typography>
    {element.image && element.image.url && (
      <img
        src={element.image.url}
        alt="image"
        style={{ width: '20%', maxWidth: '80%', height: 'auto', marginTop: '16px' }}
      />
    )}
  </RichTextContainer>
);
